import React from "react";

const WhyChooseUs = () => {
  return (
    <React.Fragment>
      <section className="h2_nh_choose-area pt-100 pb-60">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="h2_nh_choose-img mr-65 mb-40">
                <img src="/images/about-us-3.png" alt="" className="w-100" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="h2_nh_choose-content ml-70 mb-40">
                <div className="nh_section-area mb-45">
                  <span className="nh_section-subtitle">Why Choose Us</span>
                  <h2 className="nh_section-title mb-25 pb-2">
                    Why Choose NexPe?
                  </h2>
                  <p className="nh_section-text mb-25">
                    At NexPe, we aim to redefine the way you experience
                    recharges and digital payments. With a commitment to
                    excellence and customer satisfaction, we offer a platform
                    that is reliable, secure, and tailored to meet your needs.
                    Here’s what makes us stand out:
                  </p>

                  <div class="h5_nh_about-list mb-25">
                    <ul>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>Fast &
                        Reliable
                      </li>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>Secure
                        Transactions
                      </li>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>Assured
                        Cashback
                      </li>
                      <li>
                        <i class="fa-sharp fa-solid fa-check"></i>24/7 Support
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="h2_nh_about-btn">
                  <a href="/about_us" className="nh_theme-btn">
                    More Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default WhyChooseUs;
